// extracted by mini-css-extract-plugin
export default {"pagination":"PaginationComp_pagination__WwjLd","pageBtn":"PaginationComp_pageBtn__dE9Md","active":"PaginationComp_active__DxOxt","ellipsis":"PaginationComp_ellipsis__VrnzU"};